import { Instance } from 'mobx-state-tree';
import { RouteStopUpdatedDtoModelBase } from './RouteStopUpdatedDtoModel.base';

/* The TypeScript type of an instance of RouteStopUpdatedDtoModel */
export interface RouteStopUpdatedDtoModelType extends Instance<typeof RouteStopUpdatedDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopUpdatedDtoModel */
export { selectFromRouteStopUpdatedDto, routeStopUpdatedDtoModelPrimitives, RouteStopUpdatedDtoModelSelector } from './RouteStopUpdatedDtoModel.base';

/**
 * RouteStopUpdatedDtoModel
 *
 * Route stop edited event
 */
export const RouteStopUpdatedDtoModel = RouteStopUpdatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
